import { render, staticRenderFns } from "./index.vue?vue&type=template&id=18658a6c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18658a6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18658a6c')) {
      api.createRecord('18658a6c', component.options)
    } else {
      api.reload('18658a6c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=18658a6c&scoped=true&", function () {
      api.rerender('18658a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/finance/staCuXiao/index.vue"
export default component.exports